document.addEventListener('DOMContentLoaded', () => {
  // ---- Helpers ----
  const injectTemplate = (wrap, templateSelector) => {
    if (!wrap || wrap.dataset.loaded) return false;

    const tpl = wrap.querySelector(templateSelector);
    if (!tpl) return false;

    wrap.dataset.loaded = '1';
    wrap.insertAdjacentHTML('beforeend', tpl.innerHTML);
    tpl.remove();
    return true;
  };

  const tryInitJudgeMe = () => {
    try {
      // Common Judge.me init APIs (varies by version)
      if (window.jdgm && typeof window.jdgm.renderWidgets === 'function') {
        window.jdgm.renderWidgets();
        return true;
      }
      if (window.jdgm && window.jdgm.widgets && typeof window.jdgm.widgets.init === 'function') {
        window.jdgm.widgets.init();
        return true;
      }
      if (window.jdgm && typeof window.jdgm.init === 'function') {
        window.jdgm.init();
        return true;
      }
    } catch (e) {
      console.warn('[AR] Judge.me init error:', e);
    }
    return false;
  };

// ---- 1) Lazy Accelerated Checkout (real defer: fetch view) ----
const paypalWrappers = document.querySelectorAll('.ar-lazy-paypal[data-ar-dyn-checkout]');

async function loadDynCheckout(wrap) {
  if (!wrap || wrap.dataset.paypalLoaded) return;
  wrap.dataset.paypalLoaded = '1';

  const productUrl = wrap.dataset.productUrl;
  const variantId =
    document.querySelector('form[action*="/cart/add"] [name="id"]')?.value ||
    wrap.dataset.variantId;

  if (!productUrl) {
    console.warn('[AR] Missing data-product-url on .ar-lazy-paypal');
    return;
  }

  const url = variantId
    ? `${productUrl}?variant=${encodeURIComponent(variantId)}&view=dynamic-checkout`
    : `${productUrl}?view=dynamic-checkout`;

  try {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) {
      console.warn('[AR] dynamic-checkout fetch failed:', res.status, url);
      wrap.dataset.paypalLoaded = '';
      return;
    }

    const html = await res.text();
    const tmp = document.createElement('div');
    tmp.innerHTML = html;

    const btn = tmp.querySelector('.shopify-payment-button');
    if (btn) wrap.appendChild(btn);

    if (window.Shopify?.PaymentButton?.init) {
      window.Shopify.PaymentButton.init();
    }
  } catch (e) {
    console.warn('[AR] dynamic-checkout fetch error:', e);
    wrap.dataset.paypalLoaded = '';
  }
}

if (paypalWrappers.length) {
  // 1) IO (если сработает)
  if ('IntersectionObserver' in window) {
    const ioPaypal = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadDynCheckout(entry.target);
          ioPaypal.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px' }
    );

    paypalWrappers.forEach((w) => ioPaypal.observe(w));
  }

  // 2) Фолбэк: первый клик/тап гарантированно запускает загрузку
  const fallback = () => paypalWrappers.forEach(loadDynCheckout);
  window.addEventListener('pointerdown', fallback, { once: true, passive: true });
  window.addEventListener('keydown', fallback, { once: true });

  // 3) Фолбэк: если человек вообще не кликает, но кнопка должна появиться
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => paypalWrappers.forEach(loadDynCheckout), { timeout: 2500 });
  } else {
    setTimeout(() => paypalWrappers.forEach(loadDynCheckout), 2000);
  }
}




  // ---- 2) Lazy-init App Blocks (Judge.me + any app that hooks on init) ----
  // We do NOT try to template-inject app blocks (Shopify app blocks don't like that).
  // We simply trigger init when user scrolls near them.
  const appBlocks = document.querySelectorAll('.ar-lazy-appblock');

  if (appBlocks.length) {
    const ioApps = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          // Only run on product pages (reviews live there)
          if (window.location.pathname.startsWith('/products/')) {
            // Try now, then try again shortly (sometimes jdgm loads a bit later)
            const ok = tryInitJudgeMe();
            if (!ok) {
              setTimeout(tryInitJudgeMe, 800);
              setTimeout(tryInitJudgeMe, 2000);
            }
          }

          ioApps.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px' } // start before it becomes visible
    );

    appBlocks.forEach((b) => ioApps.observe(b));
  }
});